import { Trans } from "@lingui/macro"
import { Typography } from "@mui/material"
import Card from "@mui/material/Card"
import ArrowDropUp from "@mui/icons-material/ArrowDropUp";

interface Props {
    minimized: boolean,
    setMinimized: React.Dispatch<React.SetStateAction<boolean>>
}

export const Collapsed = (props: Props) => {
    return (
        <Card 
        onClick={() => props.setMinimized(!props.minimized)}
        sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width:"fit-content",
            minHeight: "fit-content",
            padding: ".5rem",
            cursor: "pointer"
        }}>
            <Typography sx={{marginRight: ".5rem"}} variant="body1"><Trans>Sign up to our newsletter!</Trans></Typography>
            <ArrowDropUp/>
        </Card>
    )
}